module.exports = __webpack_public_path__ + "img/27_49.fb1f6cad.png";